import type { ColorToken } from '@ui';
import type { FC, ReactNode } from 'react';
import type { PickProps } from '@/ui/types/types';
import { Flex } from '@ui';
import { motion } from 'framer-motion';
import { getJustifyStyle } from '@/ui/utils/getJustifyStyle';
import { tokenToVariable } from '@/ui/utils/tokenToVariable';
import styles from './Navbar.module.css';

type Props = {
    items: {
        label: string;
        href: string;
    }[];
    extraLeft?: ReactNode;
    extraRight?: ReactNode;
} & PickProps<'div', 'ref'>;

export const Navbar: FC<Props> = ({ items, extraLeft, extraRight, ...props }) => {
    const justify = getJustifyStyle(extraLeft, extraRight);

    return (
        <Flex justify={justify} align="center" className={styles.content} {...props}>
            <nav className={styles.items}>
                {items.map(item => (
                    <motion.a
                        key={item.label}
                        href={item.href}
                        initial={{ backgroundColor: 'none' }}
                        whileHover={{ backgroundColor: tokenToVariable<ColorToken>('backgroundSurfaceAccent') }}
                        whileTap={{ scale: 0.9 }}
                        className={styles.link}
                    >
                        {item.label}
                    </motion.a>
                ))}
            </nav>
            {Boolean(extraLeft) && <div className={styles.extra}>{extraLeft}</div>}
            {Boolean(extraRight) && <div className={styles.extra}>{extraRight}</div>}
        </Flex>
    );
};
